var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
    fill: "#006641"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69253 18.8799C10.3265 15.04 17.6731 15.04 19.3077 18.8799C19.3997 19.0973 19.2317 19.3333 18.9897 19.3333H9.00986C8.76787 19.3333 8.59987 19.0973 8.69253 18.8799ZM13.9998 8.66675C12.1592 8.66675 10.6665 10.1594 10.6665 12C10.6665 13.8407 12.1592 15.3333 13.9998 15.3333C15.8404 15.3333 17.3331 13.8407 17.3331 12C17.3331 10.1594 15.8404 8.66675 13.9998 8.66675Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 13.6666C20.9999 14.5873 20.2539 15.3333 19.3333 15.3333C18.4126 15.3333 17.6666 14.5873 17.6666 13.6666C17.6666 12.746 18.4126 12 19.3333 12C20.2539 12 20.9999 12.746 20.9999 13.6666ZM8.66674 12C7.74609 12 7.0001 12.746 7.0001 13.6666C7.0001 14.5873 7.74609 15.3333 8.66674 15.3333C9.58739 15.3333 10.3334 14.5873 10.3334 13.6666C10.3334 12.746 9.58739 12 8.66674 12ZM21.9872 17.1066C21.3412 15.5893 18.9159 15.276 17.5219 16.1573C18.1253 16.4719 18.6533 16.8659 19.0799 17.3333H21.8286C21.9492 17.3333 22.0332 17.2153 21.9872 17.1066ZM10.478 16.1573C9.08407 15.276 6.65877 15.5893 6.01278 17.1066C5.96678 17.2153 6.05078 17.3333 6.17211 17.3333H8.92074C9.34673 16.8659 9.87472 16.4719 10.478 16.1573Z",
    fill: "#F7F9FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommend);
export default __webpack_public_path__ + "static/media/recommend.fef3e34a88df2e7f5563a083ee95b06c.svg";
export { ForwardRef as ReactComponent };